module.exports = __webpack_public_path__ + "media/images/demo_tests/codecompare-cd712e26ce073ce446f24abcbc178cbb.png";